import { AccountMovementDataEntity } from './account-movement-data.entity';

export class AccountTableEntity {
  constructor(
    public page: number,
    public totalPages: number,
    public data: AccountMovementDataEntity[]
  ) {}
}
